import { put } from '..';

const addTicketComment = (ticketId: string, comment: string) => put(
  `assets/tickets/${ticketId}/comments`,
  { comment },
);

export default addTicketComment;
